import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "../../hooks/useLocalizedPath";
import { Container } from "../ui";
import { LinkedInIcon } from "../icons";
import styles from "./Footer.module.css";

export function Footer() {
  const { t } = useTranslation("common");
  const { lp } = useLocalizedPath();

  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.topRow}>
          <Link to={lp("/")} className={styles.brandLink}>
            <img
              src="/images/logos/logo-marque-blanc.webp"
              alt="QBP.Solutions"
              width={140}
              height={54}
              className={styles.brandLogo}
            />
          </Link>
          <div className={styles.socialButtons}>
            <a
              href="https://www.linkedin.com/company/quelbonplan/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="LinkedIn"
              data-attr="contact-linkedin"
            >
              <LinkedInIcon size={20} />
            </a>
          </div>
        </div>

        <hr className={styles.separator} />

        <div className={styles.bottomGrid}>
          <div className={styles.info}>
            <p className={styles.copyright}>© 2025 QBP.Solutions</p>
            <p className={styles.baseline}>
              {t("footer.baseline")}
            </p>
            <address className={styles.contactLine}>
              Saint-Malo ·{" "}
              <a href="mailto:partners@qbp.solutions" data-attr="contact-email">partners@qbp.solutions</a>
            </address>
            <Link to={lp("/status")} className={styles.statusLink}>
              <span className={styles.statusDot} />
              {t("footer.allSystemsOperational")}
            </Link>
          </div>

          <div className={styles.linksColumn}>
            <nav className={styles.navLinks}>
              <Link to={lp("/solutions")}>{t("nav.solutions")}</Link>
              <Link to={lp("/reprise-parc-informatique")}>{t("nav.repriseParcIT")}</Link>
              <Link to={lp("/expertise")}>{t("nav.expertise")}</Link>
              <Link to={lp("/references")}>{t("nav.references")}</Link>
              <Link to={lp("/catalogue")}>{t("nav.catalogue")}</Link>
              <Link to={lp("/about")}>{t("nav.about")}</Link>
              <Link to={lp("/contact")}>{t("nav.contact")}</Link>
            </nav>
            <nav className={styles.navLinks}>
              <a
                href="https://pro.quelbonplan.fr"
                target="_blank"
                rel="noopener noreferrer"
                data-umami-event="footer-shop-pro"
                data-attr="cta-shop-pro"
              >
                {t("footer.shopPro")}
              </a>
              <a
                href="https://quelbonplan.fr"
                target="_blank"
                rel="noopener noreferrer"
                data-umami-event="footer-shop-perso"
                data-attr="cta-shop-perso"
              >
                {t("footer.shopPerso")}
              </a>
            </nav>
            <nav className={styles.legalLinks}>
              <Link to={lp("/mentions-legales")}>{t("footer.legalNotice")}</Link>
            </nav>
          </div>
        </div>
      </Container>
    </footer>
  );
}
